import { createContext, useContext } from 'react';
import { useAnswerManager } from 'pages/forms/hooks/useAnswerManager';

export const AnswerContext = createContext({} as ReturnType<typeof useAnswerManager>);

export const useAnswerContext = () => useContext(AnswerContext);
